var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHot = function SvgIconHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-subj-hot",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M223.7 77.738c3.533 0 6-2.739 6-6.662s-6-9.338-6-9.338-6 5.413-6 9.338 2.471 6.662 6 6.662Z",
    transform: "translate(-217.703 -61.738)",
    fill: "#ff8500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "m223.424 68.91.279-.314.28.314c.09.1 2.214 2.509 2.214 4a2.494 2.494 0 1 1-4.987 0c0-1.491 2.124-3.898 2.214-4Z",
    transform: "translate(-217.703 -61.738)",
    fill: "#ffce00"
  }))));
};
export { SvgIconHot as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdWJqLWhvdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgICA8cmVjdCBpZD0iYXJlYSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSIjZjJmMmYyIiBvcGFjaXR5PSIwIi8+CiAgICA8ZyBpZD0iaWNvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCAyKSI+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfNjYiIGRhdGEtbmFtZT0iUGF0aCA2NiIKICAgICAgICAgICAgICBkPSJNMjIzLjcsNzcuNzM4YzMuNTMzLDAsNi0yLjczOSw2LTYuNjYycy02LTkuMzM4LTYtOS4zMzgtNiw1LjQxMy02LDkuMzM4UzIyMC4xNzEsNzcuNzM4LDIyMy43LDc3LjczOFoiCiAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxNy43MDMgLTYxLjczOCkiIGZpbGw9IiNmZjg1MDAiLz4KICAgICAgICA8cGF0aCBpZD0iUGF0aF82NyIgZGF0YS1uYW1lPSJQYXRoIDY3IgogICAgICAgICAgICAgIGQ9Ik0yMjMuNDI0LDY4LjkxbC4yNzktLjMxNC4yOC4zMTRjLjA5LjEsMi4yMTQsMi41MDksMi4yMTQsNGEyLjQ5NCwyLjQ5NCwwLDEsMS00Ljk4NywwQzIyMS4yMSw3MS40MTksMjIzLjMzNCw2OS4wMTIsMjIzLjQyNCw2OC45MVoiCiAgICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxNy43MDMgLTYxLjczOCkiIGZpbGw9IiNmZmNlMDAiLz4KICAgIDwvZz4KPC9zdmc+Cg==";